const actionType = {
    GET_CONCISE_CHAPTER:'GET_CONCISE_CHAPTER',
    GET_CONCISE_CHAPTER_SUCCESS:'GET_CONCISE_CHAPTER_SUCCESS',
    GET_CONCISE_CHAPTER_FAILURE:'GET_CONCISE_CHAPTER_FAILURE'
}
export default actionType 